// extracted by mini-css-extract-plugin
export default {"horizontal":"styles_horizontal__MNLmJ","vertical":"styles_vertical__9-tfp","horizontalLabel":"styles_horizontalLabel__zt7WG","verticalLabel":"styles_verticalLabel__jmWKR"};